<a id='external-interface' class="sidebar-item list-group-item"
   [href]="'#interface-menu'"
   routerLink="/app/external-interface/"
   routerLinkActive="sidebar-item-active">
    <div class="sidebar-item-wrapper">
        <i [attr.class]="'sidebar-item-icon fa fa-external-link'"></i>
        <span class="sidebar-item-text h4">
          External Interface
        </span>
    </div>
</a>

<div id="interface-menu" class="collapse">
    <ul>
        <li>A</li>
        <li>B</li>
    </ul>
</div>


